const enumHelper = {
  maxItems : 999,
  actions: {
    CHECKOUT: "checkout",
    PAY: "pay",
    CONFIRM: "confirm",
  },
  steps: {
    STEP01: "Step01",
    STEP02: "Step02",
    STEP03: "Step03",
  },
  orderType: {
    Delivery: 1,
    Collection: 2,
    Table: 3,
  },
  tabType: {
    menu: 1,
    fav: 2,
    special: 3,
  },
  status: {
    PREPARED: 0,
    SAVED: 1,
    COMPLETED: 2,
  },
  paymentType: {
    Cash: 1,
    Card: 2,
    ApplePay: 3,
    GooglePay: 4,
  },
  PickupTime: {
    ASAP: 1,
    LATER: 2,
  },
  DietaryType: {
    VEGAN: 3,
    VEGETARIAN: 4,
    DAIRYFREE: 5,
    GLUTENFREE: 6,
    HALAL: 7,
    KOSHER: 8,
    NUTS: 9,
  },
  orderStatus: {
    PENDING: 1,
    RECEIVED: 2,
    ACCEPTED: 3,
    DELIVERY: 4,
    COMPLETED: 5,
    REJECTED: 6,
    REFUNDED: 7
  },
  locales : [
    {
        'code'  : 'en',
        'flag'  : '/img/en.png',
        'name'  : 'text.english'
      },
      {
        'code': 'es',
        'flag'  : '/img/es.png',
        'name'  : 'text.spanish'
      }
  ],
  providers:{
    google:"goole",
    apple:"apple",
    facebook:"facebook"
  }
};
export default Object.freeze(enumHelper)